<template>
    <div class="uk-flex uk-flex-wrap">
        <slot />
    </div>
</template>

<script lang="js">
import Vue from "vue";

export default Vue.extend({
    name: "GraphRow",
});
</script>
